module.exports = __webpack_public_path__ + "img/bg.7f964a4d.jpg";